module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The pale, translucent forms bent over Michael Perrin once again. Had he been awake, he would have recognized three of them, but he was in a deep and dreamless sleep. Sleep was a habit he had reacquired since his return. It took him away, however briefly, from thoughts of what had happened in the Realm.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("He is pretending to be normal, ")]), _vm._v("one form said without words to her sister, hovering nearby.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Let him rest. His time will come soon enough.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Does he feel it?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("He must.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Has he told anybody yet?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Not his parents. Not his closest friends.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("He has so few close friends...")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael rolled over onto his back, pulling sheet and blankets aside to reveal his broad, well-muscled shoulders. One of the forms reached down to squeeze an arm with long fingers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Stop that.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("He keeps himself fit.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The fourth figure, shaped like a bird, said nothing. It stood by the door, lost in thought. The others retreated from the bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The fourth finally spoke. "), _c('i', [_vm._v("No one in the Council knows of this.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("It was a surprise even to us, ")]), _vm._v("the tallest of the three said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael’s eyelids flickered, then opened. He caught a glimpse of white vapor spread like wings, but it could easily have been the fog of sleep. With a start, he held up his left wrist to look at his new watch. Eight-thirty. He had slept in. There would barely be time for his exercises.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He descended the stairs in a beige sweatsuit, a gift from his parents on his most recent birthday. There had been no candles on his cake, at his request. He did not know how old he was.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His mother, Ruth, was reading the newspaper in the kitchen. “French toast in fifteen minutes,” she said, smiling at him. “Your father’s in the shop.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael returned her smile and picked up a long oak stick from beside the kitchen pantry, carrying it through the door into the back yard.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The morning was grayed by a thin fog that would burn off in just a few hours. Near the upswung door of the converted garage, his father, John, was hand-sanding a maple table top on two paint-spattered sawhorses. He looked up at Michael and forearmed mock-sweat from his brow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“My son, the jock,” Ruth said from the back steps.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I remember him still carrying stacks of books around,” John said. “Don’t be too hard on him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Breakfast lingers for no man,” she said. “Fifteen minutes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("John wiped the smooth pale surface with his fingers and applied himself to a rough spot. Michael stood in the middle of the yard and began exercising with the stick, running in place with it held out before him, hefting it back over his head and bending over to touch first one end, then the other to the grass on both sides. He had barely worked up a sweat when Ruth appeared in the doorway again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Time,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She regarded her son delicately over a cup of coffee as he ate his French toast and strips of bacon. He was less enthusiastic about bacon—or any kind of meat—than he had been before...")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But she did not bring up this observation. The subject of Michael’s missing five years was virtually taboo around the house. John had asked once, and Michael had shown signs of volunteering... And Ruth’s reaction, a stiff kind of panic, voice high-pitched, had shut both of them up immediately. She had made it quite clear she did not want to talk about it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Just as clearly, there were things she wanted to tell and could not. John had been through this before; Michael had not. The stalemate bothered him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Delicious,” he said as he carried his plate to the sink. He kissed Ruth on the cheek and ran up the stairs to change into his work clothes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael had not yet assumed the position of caretaker at the Waltiri house. The time was not right.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After two weeks of job hunting, he had been hired as a waiter in a Nicaraguan restaurant on Pico. For the past three months, he had taken the bus to work each weekday and Saturday morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At ten-thirty, Michael met the owners, Bert and Olive Cantor, at the front of the restaurant. Bert pulled out a thick ring of keys and opened the single wood-framed glass door. Olive smiled warmly at Michael, and Bert stared fixedly at nothing in particular until his wife handed him a huge mug of coffee. Shortly after Bert emptied the mug, he began issuing polite orders in the form of requests, and the day officially started.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Jesus, the Nicaraguan chef, who had arrived before six o’clock, entering through the rear, donned his apron and cap and instructed two Mexican assistants on final preparations for the day’s specials. Juanita, the eldest waitress, a stout Colombian, bustled about making sure all the set-ups were properly done and the salad bar in order.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Bert and Olive treated Michael like a lost son or at least a well-regarded cousin. They treated all their employees as if they came from various branches of the family. Ben had called the restaurant his “United Nations retirement home” after hiring Michael. “We have a red-headed Irishman, or a lookalike anyway, and half a dozen different types of Latinos, and two crazy Jews in charge.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael served on the lunch and early dinner shifts, and he studied the people he served. The restaurant attracted a broad cross-section of Angelenos, from Nicaraguans hungry for a taste of home to students from UCLA. Lunch brought in Anglo and other white-collar types from miles around.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This morning, Bert’s mug of coffee did not fix him firmly in the day. He seemed vaguely distraught, and Olive was unusually subdued. Finally, half an hour before opening, Bert took Michael into the back storeroom behind the kitchen, among the huge cans of peppers and condiments and the packages of dried herbs, and pulled out two chairs from a small table where Olive usually sat to do the books.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Bert was sixty-five, almost bald, his remaining white hair meticulously styled in a wispy swirl. He always wore a blue blazer and brown pants, a golf shirt beneath the blazer. On his right hand he sported a high school class ring with a jutting garnet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He waved this hand in small circles as he sat and shook his head. “Now don’t worry about whether you’re in trouble or not. You’re a good worker,” he said, “and you wait tables like an old pro. You’re graceful. You could even work in a snazzy place.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“This "), _c('i', [_vm._v("is")]), _vm._v(" a snazzy place,” Michael said, smiling.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, yes.” Bert looked dubious. “We’re a family. You’re part of the family. I’m saying this because you’re going to work here as long as you want, and we all like you...but you don’t belong.” He stared intently at Michael. “And I don’t mean because you should be in a university. Where are you coming from?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I was born here,” Michael answered, knowing that was also not what Bert meant.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“So? Why did you come "), _c('i', [_vm._v("here, ")]), _vm._v("to this restaurant?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I don’t know what you’re getting at.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The way you look at customers. Friendly, but...spooky. Distant. Like you’ve come from someplace a hell of a ways from here. They don’t notice. I do. So does Juanita. She thinks you’re a "), _c('i', [_vm._v("brujo, ")]), _vm._v("pardon my Spanish.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael had learned enough Spanish as a California boy to puzzle out that "), _c('i', [_vm._v("brujo ")]), _vm._v("was the masculine for "), _c('i', [_vm._v("bruja, ")]), _vm._v("witch. “That’s silly,” he said, staring off at the cans on the gray metal shelves.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I agree with Olive. Maybe even, pardon me, a "), _c('i', [_vm._v("dybbuk. ")]), _vm._v("Juanita washes dishes, and I taste the food and maybe yell once a week, but that’s both our opinions. Both ends of the rainbow think alike.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Is Olive worried?” Michael asked softly. Olive reminded him of a slightly plumper Golda Waltiri.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Bert lifted his hands in an expressive shrug. “Olive would like to have half a dozen sons, and the Lord, bless him, did not agree. She adores you. She does not think ill of you even when she sees the way you ‘learn’ our customers, the way you "), _c('i', [_vm._v("see ")]), _vm._v("them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m sorry I’ve upset you,” Michael said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Not at all. People come back. People, who knows why, enjoy being paid attention to the way you do it. You’re not in it for the advantage. But you still don’t belong here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Bert put on his look of intense concern, raised brows corrugating his high forehead. “Olive says you have a poet’s air about you. She should know. She dated a lot of poets when she was young.” He cast a quick, long-suffering look at the ceiling. “So why are you waiting tables?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I need to learn some things.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What can you learn in a trendy little dive on Pico?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“About people.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“People are everywhere.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m not used to being...normal,” Michael said. “I mean, being with people who are just...people. Good, plain people. I don’t know much about them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Bert pushed out his lips and nodded. “Juanita says that for somebody to become a "), _c('i', [_vm._v("brujo, ")]), _vm._v("something has to happen to them. Did something happen to you?” He raised his eyebrows, practically demanding candor. Michael felt oddly willing to comply.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Having struck pay dirt, Bert leaned back and seemed temporarily at a loss for what to ask next. “Are your folks okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“They’re fine,” Michael said abstractedly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Do they know?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I haven’t told them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Why not? They love you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes. I love them.” The dread was fading. Michael did not know why, but he was going to open up to Bert Cantor. “I’ve tried telling them. It’s almost come out once or twice. But Mom gets upset even before I begin. And then, it just stops, and that’s it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“How old are you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I don’t know,” Michael said. “I could be seventeen, and I could be twenty-two.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s odd,” Bert said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes,” Michael agreed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The story spun itself out from there, across several days, each day at eleven Bert drawing up the chairs and sitting across from Michael with his forehead corrugated, listening until the lunch time crowd arrived and Michael began waiting tables.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("On the fourth day, the story essentially told, Bert leaned back in his chair and closed his eyes, nodding. “That,” he said, “is a good story. Like Singer or Aleichem. A good story. This part about Jehovah being a fairy, that’s tough for me. But it’s a good one. I’m not asking to insult you—but, is it all true?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Everything’s different from what the newspapers and history books say?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Lots of things are different from what they say, yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m asking myself if I believe you. Maybe I do. Sometimes my opinions are funny that way. Are you sure it’s better here than going to college?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He nodded again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Smart boy. My son James, from a previous marriage, he’s gone to college. The professors there don’t know"), _c('i', [_vm._v(" frijoles ")]), _vm._v("about people. Books they know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I love books. I’ve been reading every day, going to the library. I need to know more about that, too.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Nothing wrong with books,” Bert agreed. “But at least you’re trying to put things in perspective.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I hope.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well,” Bert said, with a long pause after. “What are you going to do with yourself? What are you getting ready to do, I mean?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael shook his head.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I feel for you, with a story like that,” Bert said. Then he stood. “Time to wait tables.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The winter passed through Los Angeles more like an extended autumn, crossing imperceptibly into a wet and clean-aired spring such as the city had not seen in years, a sparkling, green-leafed, sun-in-water-drop spring.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The pearls appeared in Michael’s palms six months after his return from the Realm, in the first weeks of that spring. They nestled at the end of his lifeline, insubstantial, glowing in the dark like two fireflies. In two days’ time, they faded and disappeared.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The pearls confirmed what he had suspected for some weeks. Events were coming to fruition.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("So ended the pretending, his time of normality and anonymity, the last time he could truly call his own.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Rain fell for several hours after dinner, pattering on the roof above Michael’s room and chirruping down the gutters. Moonlit beads of moisture glittered on the leaves of the apricot and avocado trees in the rear yard. Rounded lines of clouds, their bottoms glowing orange-brown in the city lights, moved without haste over the Hollywood hills.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael had come upstairs to read, but he put down his book—Evans-Wentz’s "), _c('i', [_vm._v("The Fairy-Faith in Celtic Countries—")]), _vm._v("and stood before the open window, feeling the moist air lap against his face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The night birds sang again, trills sharp and liquid by turns. The trees seemed alive with song. He hadn’t heard them sing this late in months; perhaps the rain disturbed them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael closed the window, returned to his bed and leaned back on the pillow. He slept naked, disliking the restriction of pajamas, and he lay in bed as his mind took up signals like an antenna, extending itself and receiving, whether he willed it or not...")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tomorrow, Michael would leave the home of his childhood, the house of his parents, to live in the house of Arno and Golda Waltiri. He would assume control of the estate. He had planned the move since telling Bert and Olive he was quitting, but the time had never seemed exactly right.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Now it was right. Even discounting the pearls, unmistakable signs stacked themselves one upon another.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He was having unusual dreams.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He turned off the light. Downstairs, a Mozart piano piece—he didn’t know which one—played on his father’s stereo. He felt drowsy, and yet some portion of his mind stayed alert, even eager. Moonlight filled his room as the shadow of a cloud passed. Even with eyes closed to slits, he could clearly make out the framed print of Bonestell’s painting of Saturn seen from one of its closer moons.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("For the merest instant, on the cusp between sleep and waking, he saw a figure cross the print’s desolate, snow-dappled lunar landscape. The print was not in focus, but the figure seemed sharp and clear. A young—very young—Arno Waltiri smiled and beckoned...")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael twitched on the bed, eyes closed tightly now, and then relaxed, falling across continent, sky and sea.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("He saw—in some sense became—")])])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Mrs. William Hutchings Cunningham, widowed only a year, had become addicted to long treks in the new forest beyond her Sussex country home. She walked gingerly, her booted feet sinking into the damp carpet of compacted leaves, moss and loam. Early spring drizzle beaded in the fine hairs of her wool coat and cascaded from ferns disturbed by her passage.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The dividing line between the new forest and the old was not well marked, but she knew it and felt the familiar surge of love and respect as she crossed over. The great oaks, their trunks thick with startlingly green moss, tiered with moons of fungus, rose high into the whiteness. Her booted feet sank into the black wet loam and spongy moss and the slick, slippery piles of last autumn’s moldering leaves.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Mrs. Cunningham became part of the deep past whenever she crossed into the old forest. There was so little of it left in England now; patches here and there, converted to regular dun brick housing projects with distressing frequency, watched over by (she felt) corrupt or at the very least incompetent and uncaring government ministries. She raised her goose-head walking stick and poked the empty air with it, her face a mask of intense concern.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then the peace returned to her, and she found the broad flat rock in the middle of the patch of old forest, near an ancient overgrown pathway that arrowed through the trees without a single curve or waver. The trees had adapted themselves to the path, not the other way around, and yet they were centuries old. So how old was the path?")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I love you,” she said, with only the trees and the mist and the rock for witnesses. Carefully maneuvering around a black, unmarked slick of mud, she sat on the rock and let her breath out in a whuff.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was here and not by his grave, in a neatly manicured cemetery miles and miles away, that she came to hold communion with her late husband. “I love you, William,” she said, face downturned but dark brown eyes peering up. The mist’s minute droplets slipped into the wrinkles of her face and made lines of sheen. She closed her eyes and leaned her head back to feel the droplets land on her eyelids and lips.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Do you remember,” she said, “when we were just married, and there was that marvelous inn, The Green Man, and the innkeeper wanted to see "), _c('i', [_vm._v("our ")]), _vm._v("identification, wanted to know how old "), _c('i', [_vm._v("we")]), _vm._v(" were?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("For some, such a process, day in and day out, would have signified an unwholesome self-torture. But not for her. She could feel the distance growing between herself and the past, and she could feel the wounds healing. This was how she kept a bandage on her injuries, protecting them with a bit of ritual against the abrasions of hard reality.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Do you remember, too—” she began, then stopped abruptly, eyes turning slowly to the path.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A tall dark figure, walking on the path miles beyond the trees, yet still visible, approached the rock on which she sat. It seemed she waited for hours, but it was only a minute or two, as the figure grew larger and more distinct, coming at last to the extent of the path that Mrs. Cunningham would have called real.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A tall, pale-skinned woman arrived at the rock and paused, drifting forward as if from ghostly momentum as she turned to look at Mrs. Cunningham. The tall woman had dark red hair and a thin ageless face with deep-set eyes. She wore a gray robe that was really a translucent, nacreous black.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Mrs. Cunningham had not seen her like before. She felt a feather-touch at the back of her thoughts, and the woman spoke. With each word, the uncertain image became more solid, as if speaking finished the act of becoming part of this reality.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I am on the Earth of old, am I not?” the woman asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I think so,” Mrs. Cunningham said, as brightly as she could manage, or dared.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Do you grieve?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No.” Mrs. Cunningham’s expression turned quizzical, with a touch of pain. “Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“For a loved one?” the woman asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“For my husband,” she replied, her throat very dry.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Silly grief, then,” the woman said. “You do not know the meaning of grief.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Perhaps not,” Mrs. Cunningham conceded, feeling this was more than impertinence or rudeness, “but it feels to me as if I do.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You should not sit on that rock much longer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh?” She tightened her face, resolute.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The woman pointed back up the path. “More of my kind coming,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh.” Mrs. Cunningham stared at the path, head nodding slightly, eyes wide.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The tall woman’s pale face glowed against the dark trees and misty sky. “I say that your grief is a silly grief, for he is not lost forever, as we are, and you have paid mortality for infinity, and that we cannot.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh,” Mrs. Cunningham said again, as if engaged in conversation with a neighbor. The woman’s eyes were extraordinary, like holes into a silver-blue arctic landscape, with hints of opalescent fire. Her red hair hung in thick strands around her shoulders, and her black gown seemed alive with moving leaves in lighter shades of gray. A golden tassel dangling from her midriff had a snaky life of its own.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We are back now,” she said to Mrs. Cunningham. “Please do not cross the trod hereafter.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I certainly won’t,” Mrs. Cunningham vowed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The woman pointed a long-fingered hand at the rock. Mrs. Cunningham removed herself several yards, slipping once on the patch of leaves and mud. The woman drifted down the path, not walking on quite the same level, and was surrounded by trees away from Mrs. Cunningham’s view.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She stood, her lips working in prayer, and then returned her attention to the direction from which the woman had come. “The Lord is my shepherd,” she murmured. “The Lord is my shepherd. I shall not want—“")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There were more, indeed. Three abreast and of all descriptions, from deepest shadows without feature to mere pale wisps like true spirits, some dripping water, some seeming to be made of water, some as green as the leaves in the canopy above, and following them, a number of beautiful and sinewy horses with shining silver coats...and all, despite their magnificence, with an air of weary refugee desperation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Mrs. Cunningham, after a few minutes, decided discretion would be best, and retreated farther from the path—the trod—with her eyes full of tears for the beauty she had seen that day, and for the message of the woman with red hair in the living black gown.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Paying mortality for infinity...")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Yes, she could understand that.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“William, oh "), _c('i', [_vm._v("William,” ")]), _vm._v("she breathed, fairly running through the woods. “You wouldn’t "), _c('i', [_vm._v("believe...")]), _vm._v("what has...just happened...here...” She came to the boundary and crossed into new forest, and the sensation dulled but did not leave her entirely.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But whom will I tell?” she asked. “They’re back, all—or some—of the Faerie folk, and who will believe me now?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael opened his eyes slowly and stared at the dawn as it cast dim blue squares on the closed curtains.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Behind the vision of Mrs. Cunningham had been another and darker one. He had seen something long and sinuous swimming with ageless grace through murky night waters, watching him from a quarter of the way around the world. In that watching there was appraisal.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("On the morning of his move, Ruth offered one last time to help him get settled in the Waltiri house. Michael politely refused. “All right, then,” she said, dishing up one last homecooked breakfast of fried eggs and toast—consciously leaving out the bacon. “Promise me you won’t take things so seriously.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He regarded her solemnly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“At least try to loosen up. Sometimes you are positively gloomy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Don’t nag the fellow,” John said, holding one thumb high to signal friendly banter and not domestic disagreement.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael grinned, and Ruth stared at him with wistfulness and then something like awe. He could almost read her thoughts. This was her son, with the strong features so like his father’s and the hair so like her own—but there was something not at all comforting in his face, something lean and...")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fierce. "), _c('i', [_vm._v("Where had he been for five years?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael walked, suitcases in hand, in the pale rich light of morning. Dew beaded the lawns of the old homes and dripped from the waxy green leaves of camellia and gardenia bushes. The sidewalks steamed in the sun, mottled olive and gray with moisture from last night’s rain.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He passed a group of five school girls, twelve or thirteen years old, dressed in white blouses and green and black plaid skirts with black sweaters. They averted their faces as they passed but not their eyes, and Michael sensed one or two turning, walking backward, to continue staring at him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The possibilities offered by his appearance seldom concerned him; he appreciated the attention of women but took little advantage. He still felt guilty about Eleuth, the Breed who had given her life for him, and thought often of Helena, whom he had treated as Eleuth had deserved to be treated.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("For that and other reasons there was a deep uncertainty in him, a feeling that he had somehow twisted his foot at the starting line and entered the race crippled, that he had made bad mistakes that lessened his chances of staying ahead. He was certain about neither his morals nor his competence.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He set the bags down on the front porch of the Waltiri house. Using the keys given to him by the estate’s attorneys, he opened the heavy mahogany door. The air within was dry and noncommittal. Plastic sheets had been draped over the furniture. Gritty gray dust lay over everything.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He took the bags into the hall and set them down at the foot of the stairs. “Hello,” he said nervously. Waltiri’s presence still seemed strong enough that a hale answer wouldn’t have surprised him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The upstairs guest bedroom became his first project. He searched for a storage closet, found it beneath the stairs and pulled out a vacuum cleaner—an old upright Hoover with a red cloth bag. He cleared the hardwood floors of dust upstairs and down, then removed from the same closet and rolled out the old oriental carpets and stair runners, fixing the brass rods to keep them in place. Removing yellow-edged sheets from the linen closet, he made up the brass bed in the guest room, removed the plastic covers from all chairs and tables and sofas and folded them into neat squares.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He then went from room to room in the huge old house, standing in each and acquainting himself with their new reality—devoid of Waltiri or Golda. The house was his responsibility now, his place to live for the time being, if not yet his home.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael had spent most of his life in one house. Getting accustomed to a different one, he realized, would take time. There would be new quirks to learn, new layouts to become used to. He would have to re-create the house in his head and cut new templates to determine his day-to-day paths.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In the kitchen, he plugged in the refrigerator, removed a box of baking soda from the interior, and unchocked the double doors to let them swing shut. The pantry—a walk-in affair, shelved floor-to-ceiling and illuminated by a bare bulb hanging from a thick black cord—had been stocked full of canned and dry goods, all usable except for a bloated can of pineapple that rocked to his touch. He threw it out and made up a list of the few items he would need to buy.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In the triple garage behind the house, a 1939 black Packard sat up on blocks next to a maze of metal shelves stacked high with file boxes. Michael walked around the beauty, fingering a moon of dust from its fender and observing the shine of the chrome. Enchanting, but not practical. Leaded premium gas (called ethyl in the Packard’s heyday) was becoming difficult to find; besides, it would draw attention—something he wanted to avoid and be incredibly expensive to maintain. He peered through the window and then opened the door and sat behind the wheel. The interior smelled new: leather and saddle-soap and that other, citrusy-metallic odor of a new car. The Packard might have been driven out of the showroom the day before. All it needed was air in the tires, and his father would help him remove the blocks, he was sure—just for a chance to touch the fine woodwork.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael saw a speck of ivory peeking from between the seat and seatback on the right—a folded piece of paper. He pulled it loose and read the cover.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Première Performance")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("THE INFINITY CONCERTO")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Opus 45")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("by Arno Waltiri")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("8:00 P.M. November 23rd")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Pandall Theater")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("8538 Sunset Boulevard")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Within the fold was a listing of all the players in the Greater Los Angeles Symphonia Orchestra. There were no other notes or explanations. After staring at the program for several minutes, Michael lay it back on the seat and took a deep breath.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Parked outside by the east wall of the garage, in a short cinderblock-walled alley, was a late-1970s-model Saab. Michael unlocked the door on the driver’s side and sat in the gray velour bucket seat, resting his hands on the steering wheel.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Much more practical.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He had ridden Sidhe horses, "), _c('i', [_vm._v("abana ")]), _vm._v("from point to point in the Realm, and touched a myriad of ghostly between-worlds, and yet he still felt pride and pleasure at sitting in a car, knowing it would be his to drive whenever and wherever he pleased. He was still that much a child of his times. After a long search for the latch, he popped open the hood and peered at the unfamiliar engine. The battery cables had been unhooked. He reattached them to the posts. The tires did not need air. It was ready to drive.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael knew enough about fuel injection systems not to depress the gas pedal when starting the engine. The engine turned over with a throaty rumble on the first try. He smiled and twisted the wheel this way and that, then backed it carefully out of the alley, reversed it on the broad expanse of concrete before the garage and drove to the supermarket.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("That evening, he inspected the living room fireplace and chimney and brought wood in from where it had been stacked beside the Packard. In a few minutes, a lusty blaze brightened the living room and shone within the black lacquer of the grand piano. Michael sat in Waltiri’s armchair and sipped a glass of Golda’s Amontillado, his mind almost blank, almost contented.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He was not the same boy he had been when he entered Sidhedark through the house of David Clarkham. He doubted he was a boy at all.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Crane Women had trained him well; he didn’t doubt that. He had survived the worst Sidhedark had to offer—monstrous remnants of Tonn’s early creation; the ignorant and frustrated cruelty of the Wickmaster Alyons; Tarax and Clarkham himself. But what had he been trained for? Merely to act as a bomb delivering destruction to the Isomage, as Clarkham had called himself? Or for some other purpose besides?")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The flames danced with wicked cheer in the broad fireplace, and the embers glowed like holes opening onto a beautiful and deadly world of pure heat and light.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He drowsed, grateful that no new visions bothered him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At midnight, the rewound grandfather clock in the foyer chimed and awoke him. The fire had died to fitful coals. He climbed up to the guest room, now his bedroom, and sank into the cool, soft mattress.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Even in deep sleep, part of him seemed aware of everything.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("One")]), _vm._v(", the clock announced in its somber voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Two")]), _vm._v(". (The house creaking.)")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Three")]), _vm._v(". (A light rain began and ended within minutes.)")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Four")]), _vm._v(". (Night birds...)")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Five")]), _vm._v(". (Almost absolute stillness.)")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At six, the clock’s tone coincided with the sound of a newspaper hitting the front door. Michael’s eyes opened slowly. He was not in the least groggy. There had been no dreams.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In his robe, he went downstairs to retrieve the paper, wrapped in plastic against the wet. A man sang softly and randomly in the side yard of the house on the left. Michael smiled, listening to the lyrics.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Don’t cry for me, ArgenTEEEENA...” The man walked around the corner and saw Michael. “Good morning!” he called out, shaking his head sheepishly and waving. He was in his early forties, portly, with abundant light-brown hair and a face indelibly stamped with friendliness. “Didn’t disturb you, I hope.” He wore a navy blue jogging suit with bright red stripes down the sleeves and legs.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No,” Michael said. “Getting the paper.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Just going to do some running. You knew Arno and Golda?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m taking care of the house for them,” Michael said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You sound like maybe they’re coming back,” the man said, pursing his mouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael smiled. “Arno appointed me. I’m going to organize the papers...”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Now"), _c('i', [_vm._v(" that’s ")]), _vm._v("a job.” The man had walked in Michael’s direction, and they now stood a yard apart. He extended his hand, and Michael shook it. “I’m Robert Dopso. Next door. Arno and Golda were fine neighbors. My mother and I miss them terribly. I was married, but...” He shrugged. “Divorced, and I moved back here. Momma’s boy, I know. But Mom was very lonely. I grew up here; my father bought the house in 1940. Golda and Mom used to talk a lot. My life in a nutshell.” He grinned. “Your name?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael told him and mentioned he had just moved in the day before.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m not bad in the fix-it department,” Dopso said. “I helped Golda with odds and ends after Arno died. I might know a few tricks about the place... If you need any help, don’t hesitate to ask. My wife kept me around a year longer because without me, she said, everything stayed broken.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll ask,” Michael said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Maybe we could walk or run together—whichever. I prefer running, but...”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael nodded, and Dopso headed down the street. “You were supposed to BEEE IMMORTal...”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Michael carried the paper into the kitchen. There, he ate a bowl of hot oatmeal and leafed through the front section. Most of the news—however important and ominous it might seem to his fellows—barely attracted his attention.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then he came to a small third-page story headlined")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("CORPSES FOUND IN ABANDONED BUILDING")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("and his eyes grew wide as he read:")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The unidentified bodies of two females were found by a transient male in the abandoned Tippett Residential Hotel on Sunset Boulevard near La Cienega Sunday afternoon. Cause of death has not been established by the coroner’s office. Reporters’ questions went largely unanswered during a short press briefing. Early reports indicate that one of the women weighed at least eight hundred pounds and was found nude. The second body was in a mummified condition and was clothed in a party dress of a style long since out of fashion. The Tippett Hotel, abandoned since 1968, once offered a posh Hollywood address for retired and elderly actors, actresses and other film workers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He read the piece through several times before folding the paper and putting it aside. His oatmeal cooled in its bowl, half finished.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The bodies might be a coincidence, he thought. As rare as eight-hundred-pound women were...")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But in conjunction with a mummy, clothed in a party dress?")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He called up the paper’s city desk and asked to speak to the reporter who had written the piece, which had run without a byline. The reporter was out on assignment, he was told, and the operator referred him to a police phone number. Michael paced the kitchen and adjacent hall for several minutes before deciding against phoning the police. How would he explain?")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He had to have a look at that building. Something nagged him about the address. Sunset and La Cienega... Barely five miles from Waltiri’s house.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He went to the Packard and retrieved the concert program, then checked the glove box in the Saab to find a city map. He took both to Waltiri’s first-floor office, dark and musty and lined with shelves of records and tapes, and tried to locate 8538 Sunset Boulevard, the site of the Pandall Theater according to the concert program.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The address was less than half a block from the corner of Sunset and La Cienega.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1323b945","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section3.vue
// module id = 72
// module chunks = 0